$(document).ready(function () {
    $(".nav-main [data-menu=1]").click(function () {
        let ul = $(this).children("ul");
        $(ul).addClass("shown");
    });

    $(".nav-main [data-menu-back]").click(function (e) {
        e.stopPropagation();
        $(this).parent().removeClass("shown");
    });
});
